import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from '../../../../components/shared/Button/Button';
import { closeAccount } from '../../../../redux/actions/userActions';

import CloseAccountModal from './CloseAccountModal/CloseAccountModal';

import styles from './CloseAccount.module.scss';

const CloseAccount = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();

  const [showClosureModal, setShowClosureModal] = useState(false);

  const handleModalSubmit = useCallback((userId, userPassword, closureReasons, otherReason) => {
    setShowClosureModal(false);
    dispatch(closeAccount(userId, userPassword, closureReasons, otherReason));
  }, []);

  return (
    <div className={styles.container}>
      <p className={styles.contentHeading}>{t('account.closeAccount')}</p>
      <p>{t('closeAccount.breakDescription')}</p>
      <Button onClick={() => setShowClosureModal(true)} variant="secondary" className={styles.closeAccountButton}>
        {t('closeAccount.seeOptions')}
      </Button>
      {showClosureModal && (
        <CloseAccountModal onClose={() => setShowClosureModal(false)} handleSubmit={handleModalSubmit} />
      )}
    </div>
  );
};

export default CloseAccount;
